(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upgrade"] && !Shopify.designMode) return;
  try {
    class CartUpgradeLink extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button');
      if (!button) return;
      button.disabled = false;
      button.addEventListener('click', () => {
        const url = new URL(this.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('lp_upgrade', this.dataset.source);
        url.searchParams.set('lp_upgrade_id', crypto.randomUUID());
        window.location.assign(url.href);
      });
    }
  }
  if (!customElements.get('cart-upgrade-link')) customElements.define('cart-upgrade-link', CartUpgradeLink);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    /* Reports consent to Shopify, which is what actually gates pixels, audiences
     and checkout. The banner's own visibility is the cosmetic half;
     setTrackingConsent is the half that counts. */
  class CookieConsent extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.consent__panel');
      this.choices = this.querySelector('[data-consent-choices]');
      this.saveButton = this.querySelector('[data-consent-save]');
      this.customiseButton = this.querySelector('[data-consent-customise]');

      this.querySelector('[data-consent-accept]').addEventListener('click', () => this.setAll(true));
      this.querySelector('[data-consent-reject]').addEventListener('click', () => this.setAll(false));
      this.customiseButton.addEventListener('click', () => this.reveal());
      this.saveButton.addEventListener('click', () => this.saveChoices());

      // Any control anywhere can reopen it — that is the footer link's job,
      // and withdrawing consent has to be as reachable as giving it.
      document.addEventListener('click', (event) => {
        if (!event.target.closest('[data-consent-open]')) return;
        event.preventDefault();
        this.reveal(true);
      });

      this.loadApi();
    }

    loadApi() {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) return;
          this.api = window.Shopify.customerPrivacy;
          if (!this.api) return;

          // Only a visitor in an opt-out jurisdiction is shown the sale-or-
          // sharing row. Shopify already honours Global Privacy Control in
          // those regions, so a GPC signal will have set this to denied before
          // the visitor ever sees the panel.
          if (typeof this.api.saleOfDataRegion === 'function' && this.api.saleOfDataRegion()) {
            this.saleRow = this.querySelector('[data-consent-sale]');
            if (this.saleRow) this.saleRow.hidden = false;
          }

          // shouldShowBanner() answers "is this visitor in a region that needs
          // asking, and have they not already answered" — both halves matter.
          if (this.api.shouldShowBanner()) this.show();
        }
      );
    }

    show() { this.hidden = false; }

    hide() {
      this.hidden = true;
      this.classList.remove('consent--open');
    }

    /* Reopening prefills from the stored decision, so "customise" after a
       previous visit shows what was actually chosen rather than a blank slate. */
    reveal(fromControl) {
      if (fromControl) this.show();
      this.classList.add('consent--open');
      this.choices.hidden = false;
      this.saveButton.hidden = false;
      this.customiseButton.hidden = true;

      const current = this.api && this.api.currentVisitorConsent ? this.api.currentVisitorConsent() : {};
      for (const input of this.choices.querySelectorAll('[data-consent-category]')) {
        input.checked = current[input.dataset.consentCategory] === 'yes';
      }
      this.choices.querySelector('input:not([disabled])')?.focus();
    }

    setAll(value) {
      this.submit({ analytics: value, marketing: value, preferences: value, sale_of_data: value });
    }

    saveChoices() {
      const consent = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      for (const input of this.choices.querySelectorAll('[data-consent-category]')) {
        // The sale row is skipped outside opt-out regions, so its value stays
        // false rather than inheriting whatever marketing was set to.
        if (input.dataset.consentCategory === 'sale_of_data' && this.saleRow?.hidden !== false) continue;
        consent[input.dataset.consentCategory] = input.checked;
      }
      this.submit(consent);
    }

    submit(consent) {
      if (!this.api) return this.hide();
      this.api.setTrackingConsent(consent, () => this.hide());
    }
  }

  if (!customElements.get('cookie-consent')) customElements.define('cookie-consent', CookieConsent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drawer"] && !Shopify.designMode) return;
  try {
    /* The drawer closes itself.

     It used to rely on the header's delegated click handler, which is scoped
     to <site-header> — so every drawer inside the header worked and the design
     picker, which lives inside <set-builder> on a product page, had a close
     button with nothing listening to it. A primitive that cannot be closed
     unless it happens to be mounted in one particular section is not a
     primitive.

     One document-level listener covers every drawer on the page, present or
     added later. Opening stays with whoever owns the trigger. */
  if (!window.__laposeDrawerClose) {
    window.__laposeDrawerClose = true;
    document.addEventListener('click', (event) => {
      const closer = event.target.closest('[data-drawer-close]');
      if (closer) {
        closer.closest('dialog')?.close();
        return;
      }
      // Clicking the backdrop means clicking the dialog itself, since the
      // panel is a child that covers only part of it.
      if (event.target instanceof HTMLDialogElement && event.target.classList.contains('drawer')) {
        event.target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["set-builder"] && !Shopify.designMode) return;
  try {
    /* The component owns none of the data. Every value it shows is read back out
     of the <select> elements the server rendered, so the form is the single
     source of truth and the chips are a view of it — which is what makes the
     no-script path and the enhanced path agree by construction. */
  class SetBuilder extends HTMLElement {
    connectedCallback() {
      this.browseOnly = this.dataset.browseOnly === 'true';
      this.fields = [...this.querySelectorAll('[data-field]')];
      this.selects = this.fields.map((f) => f.querySelector('[data-design-select]'));
      this.tiers = [...this.querySelectorAll('[data-tier]')];
      this.slots = this.querySelector('[data-slots]');
      this.tally = this.querySelector('[data-tally]');
      this.done = this.querySelector('[data-done]');
      this.why = this.querySelector('[data-why]');
      this.add = this.querySelector('[data-add]');
      this.addLabel = this.querySelector('[data-add-label]');
      this.summarySet = this.querySelector('[data-summary-set]');
      this.summaryPrice = this.querySelector('[data-summary-price]');
      this.picker = document.getElementById(this.dataset.picker);
      this.active = 0;
      const upgradeUrl = new URL(window.location.href);
      this.upgradeKey = upgradeUrl.searchParams.get('lp_upgrade');
      if (this.upgradeKey) {
        this.upgradeOperation = upgradeUrl.searchParams.get('lp_upgrade_id') || crypto.randomUUID();
        upgradeUrl.searchParams.set('lp_upgrade_id', this.upgradeOperation);
        window.history.replaceState(null, '', upgradeUrl.href);
      }
      this.upgradeState = this.upgradeKey ? 'loading' : null;
      this.root = window.Shopify?.routes?.root || '/';

      this.querySelector('form')?.addEventListener('submit', (event) => {
        const filled = this.selects.filter((select) => select.value).length;
        const tier = this.tierFor(filled);
        if (this.browseOnly || tier?.dataset.available !== 'true' || !this.isComplete(filled, tier)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        if (this.upgradeKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.upgradeState === 'ready') this.submitUpgrade(tier);
        }
      }, true);

      if (!this.selects.length || !this.slots) return;

      // Only now are the dropdowns redundant.
      for (const field of this.fields) field.hidden = true;
      this.slots.hidden = false;

      for (const tier of this.tiers) {
        tier.addEventListener('change', () => this.pickTier(tier));
      }
      for (const select of this.selects) {
        select.addEventListener('change', () => this.paint());
      }

      this.slots.addEventListener('click', (event) => {
        const clear = event.target.closest('[data-slot-clear]');
        if (clear) {
          event.stopPropagation();
          this.removeDesign(Number(clear.dataset.slotClear));
          return;
        }
        const slot = event.target.closest('[data-slot]');
        if (slot) this.open(Number(slot.dataset.slot));
      });

      this.picker?.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-picker-tab]');
        if (tab) { this.switchPickerTab(tab.dataset.pickerTab); return; }
        const remove = event.target.closest('[data-picker-remove]');
        if (remove) {
          const index = Number(remove.dataset.pickerRemove);
          this.removeDesign(index);
          this.picker.querySelector(`[data-picker-slot="${index}"]`)?.focus();
          return;
        }
        const slot = event.target.closest('[data-picker-slot]');
        if (slot) { this.active = Number(slot.dataset.pickerSlot); this.switchPickerTab('manicure'); this.paintPicker(); return; }
        const decrement = event.target.closest('[data-picker-decrement]');
        if (decrement) {
          const index = this.selects.map(select => select.value).lastIndexOf(decrement.dataset.pickerDecrement);
          if (index >= 0) this.removeDesign(index);
          return;
        }
        const option = event.target.closest('[data-design]');
        if (!option || this.active < 0 || !this.selects[this.active]) return;
        this.selectionStarted = true;
        this.selects[this.active].value = option.dataset.design;
        this.active = this.selects.findIndex(select => !select.value);
        this.paint();
      });
      this.picker?.querySelectorAll('[data-picker-tab]').forEach(tab => tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.picker.querySelectorAll('[data-picker-tab]')];
        const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[1] : tabs.find(item => item !== tab);
        this.switchPickerTab(next.dataset.pickerTab);
        next.focus();
      }));

      const search = this.picker?.querySelector('[data-picker-search]');
      search?.addEventListener('input', () => this.filter(search.value));
      // A type="search" field swallows the first Escape to clear itself, so
      // the modal would need two presses to close from inside the field. One
      // key, one action — the native clear button is still there for clearing.
      search?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.picker.close();
      });

      this.add.addEventListener('click', (event) => {
        if (this.add.getAttribute('aria-disabled') !== 'true') return;
        event.preventDefault();
        const first = this.slots.querySelector('[data-slot].slot--empty');
        first?.focus();
        first?.click();
      });

      this.wireFilters();

      const checked = this.tiers.find((t) => t.checked) || this.tiers[0];
      if (checked) this.pickTier(checked, true);
      this.paint();
      if (this.upgradeKey) this.loadUpgrade();
    }

    async cartRequest(path, body) {
      const response = await fetch(this.root + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {})
      });
      const data = await response.json();
      if (!response.ok) {
        const error = new Error(data.description || data.message || this.dataset.upgradeError);
        error.shopify = true;
        throw error;
      }
      return data;
    }

    sourceFingerprint(item) {
      return JSON.stringify([item.variant_id, item.quantity, item.properties || {}, item.selling_plan_allocation || null]);
    }

    upgradeMessage(message, error = false) {
      const node = this.querySelector(error ? '[data-upgrade-error]' : '[data-upgrade-note]');
      if (node) { node.hidden = false; node.textContent = message; }
      const link = this.querySelector('[data-upgrade-cart]');
      if (link) link.hidden = !error;
    }

    async loadUpgrade() {
      this.upgradeMessage(this.dataset.upgradeLoading);
      try {
        const cart = await this.cartRequest('cart.js');
        if (cart.items.some((item) => item.properties?._lp_upgrade === this.upgradeOperation)) throw new Error();
        const source = cart.items.find((item) => item.key === this.upgradeKey);
        const tier = this.wanted || this.tiers.find((item) => item.checked);
        if (!source || !tier || source.selling_plan_allocation) throw new Error();
        const sourceCount = source.product_type === 'Gel sans UV' ? 1 : parseInt(source.variant_title, 10);
        const targetCount = Number(tier.dataset.count);
        if (!((sourceCount === 1 && targetCount === 2) || (sourceCount === 2 && targetCount === 3) || (sourceCount === 4 && targetCount === 6))) throw new Error();
        if (sourceCount !== 1 && String(source.product_id) !== this.dataset.productId) throw new Error();
        let designs;
        if (sourceCount === 1) {
          designs = [source.product_title];
        } else {
          designs = Object.entries(source.properties || {})
            .filter(([key, value]) => /^Design \d+$/.test(key) && typeof value === 'string' && value)
            .sort(([a], [b]) => parseInt(a.split(' ').pop(), 10) - parseInt(b.split(' ').pop(), 10))
            .map(([, value]) => value);
        }
        if (designs.length !== sourceCount || designs.some((value) => ![...this.selects[0].options].some((option) => option.value === value))) throw new Error();
        this.upgradeSource = source;
        this.upgradeFingerprint = this.sourceFingerprint(source);
        this.upgradeMinCount = targetCount;
        this.selects.forEach((select, index) => { select.value = designs[index] || ''; });
        this.tiers.forEach((input) => { if (Number(input.dataset.count) < targetCount) input.disabled = true; });
        this.upgradeState = 'ready';
        this.upgradeMessage(this.dataset.upgradeReady);
      } catch {
        this.upgradeState = 'blocked';
        this.upgradeMessage(this.dataset.upgradeError, true);
      }
      this.paint();
    }

    async submitUpgrade(tier) {
      if (this.upgradeState !== 'ready') return;
      this.upgradeState = 'saving';
      this.paint();
      let marker;
      let added = false;
      let source;
      try {
        const before = await this.cartRequest('cart.js');
        if (before.items.some((item) => item.properties?._lp_upgrade === this.upgradeOperation)) throw new Error();
        source = before.items.find((item) => item.key === this.upgradeKey);
        if (!source || this.sourceFingerprint(source) !== this.upgradeFingerprint) throw new Error();
        const values = this.selects.map((select) => select.value).filter(Boolean);
        if (values.length !== Number(tier.dataset.count) || values.length < this.upgradeMinCount) throw new Error();
        marker = this.upgradeOperation;
        const properties = {};
        for (const [key, value] of Object.entries(source.properties || {})) {
          if (!/^Design \d+$/.test(key) && key !== '_lp_upgrade') properties[key] = value;
        }
        values.forEach((value, index) => { properties[this.dataset.propertyStem + ' ' + (index + 1)] = value; });
        properties._lp_upgrade = marker;
        let addError;
        try {
          await this.cartRequest('cart/add.js', { items: [{ id: Number(tier.value), quantity: 1, properties }] });
        } catch (error) { addError = error; }
        const afterAdd = await this.cartRequest('cart.js');
        const newLine = afterAdd.items.find((item) => item.properties?._lp_upgrade === marker);
        if (!newLine || newLine.quantity !== 1 || String(newLine.variant_id) !== String(tier.value)) {
          if (newLine) added = true;
          throw addError || new Error();
        }
        added = true;
        const currentSource = afterAdd.items.find((item) => item.key === source.key);
        if (!currentSource || this.sourceFingerprint(currentSource) !== this.upgradeFingerprint) throw new Error();
        try {
          await this.cartRequest('cart/change.js', { id: currentSource.key, quantity: source.quantity - 1 });
        } catch {}
        const afterRemove = await this.cartRequest('cart.js');
        const remaining = afterRemove.items.find((item) => item.key === source.key);
        const replacement = afterRemove.items.find((item) => item.properties?._lp_upgrade === marker);
        if ((remaining?.quantity || 0) !== source.quantity - 1 || replacement?.quantity !== 1) throw new Error();
        this.upgradeState = 'complete';
        window.location.assign(this.root + 'cart');
      } catch (error) {
        let unchanged = false;
        try {
          let current = await this.cartRequest('cart.js');
          let replacement = marker && current.items.find((item) => item.properties?._lp_upgrade === marker);
          const remaining = source && current.items.find((item) => item.key === source.key);
          if (source && replacement?.quantity === 1 && (remaining?.quantity || 0) === source.quantity - 1) {
            this.upgradeState = 'complete';
            window.location.assign(this.root + 'cart');
            return;
          }
          if (replacement && remaining && this.sourceFingerprint(remaining) === this.upgradeFingerprint) {
            await this.cartRequest('cart/change.js', { id: replacement.key, quantity: 0 });
            current = await this.cartRequest('cart.js');
            replacement = current.items.find((item) => item.properties?._lp_upgrade === marker);
          }
          const original = current.items.find((item) => item.key === this.upgradeKey);
          unchanged = !replacement && original && this.sourceFingerprint(original) === this.upgradeFingerprint;
        } catch {}
        this.upgradeState = 'blocked';
        const message = unchanged ? this.dataset.upgradeUnchanged : this.dataset.upgradeReview;
        this.upgradeMessage(error.shopify && !added && unchanged ? error.message + ' ' + message : message, true);
        this.paint();
      }
    }

    wireFilters() {
      const chips = [...(this.picker?.querySelectorAll('[data-filter]') || [])];
      if (!chips.length) return;
      for (const chip of chips) {
        chip.addEventListener('click', () => {
          for (const other of chips) other.classList.toggle('is-active', other === chip);
          this.tag = chip.dataset.filter;
          this.filter(this.picker.querySelector('[data-picker-search]')?.value || '');
        });
      }
    }

    /* Every slot always exists; the count is how many are filled, and that is
       what chooses the variant. Nothing here calculates money — it picks the
       variant Shopify already priced. */
    get rewards() {
      if (this._rewards) return this._rewards;
      this._rewards = new Map();
      for (const entry of (this.slots.dataset.rewards || '').split('|')) {
        const [count, pct, perk] = entry.split(':');
        if (count) this._rewards.set(Number(count), { pct: Number(pct || 0), perk: perk || '' });
      }
      return this._rewards;
    }

    get count() { return this.selects.length; }

    /* Mix & Match always follows the filled count, regardless of the entry
       variant. A requested Starter tier and an explicit cart replacement keep
       their target; removing a design clears the ordinary requested tier. */
    tierFor(filled) {
      const usable = this.tiers.filter((t) => !t.disabled);
      const ceiling = usable
        .filter((t) => Number(t.dataset.count) >= Math.max(filled, 1))
        .sort((a, b) => Number(a.dataset.count) - Number(b.dataset.count))[0];
      if (this.upgradeKey && this.upgradeMinCount) {
        return usable.filter(t => Number(t.dataset.count) >= Math.max(filled, this.upgradeMinCount)).sort((a,b) => Number(a.dataset.count)-Number(b.dataset.count))[0] || null;
      }
      if (usable.some(t => Number(t.dataset.count) < 4) && this.wanted && !this.wanted.disabled && Number(this.wanted.dataset.count) >= filled) return this.wanted;
      return ceiling || null;
    }

    /* The variant the order is actually priced at right now — checked here and
       nowhere else, so the radios can never disagree with the grid. */
    syncTier(filled) {
      const match = this.tierFor(filled);
      for (const t of this.tiers) t.checked = t === match;
      return match || null;
    }

    /* Filled to the size the tier includes. Being ON the 4 tier with three
       designs picked is a half-built set, not a priced one — the button says so
       and refuses, which is the same contract as before, just with the tier
       chosen for the shopper instead of against them. */
    isComplete(filled, tier) {
      return !!tier && filled === Number(tier.dataset.count);
    }

    pickTier(tier, quiet) {
      const count = Number(tier.dataset.count || 1);
      this.wanted = tier;
      /* Values beyond the new size are dropped, not kept out of sight: a hidden
         design that reappears when the shopper trades back up is a property
         they never chose.

         They are cleared but NOT disabled. A disabled <select> submits nothing,
         so a slot the shopper later fills while the radio still says "2
         designs" would have gone to the shop as an order with the design
         missing — and disabling is also what made growing into the next tier
         impossible, since the slot that would take them there could not be
         filled. Nothing beyond the tier can be submitted anyway: the tier is
         the ceiling of the filled count, so filled never exceeds it. */
      this.selects.forEach((select, i) => {
        select.disabled = false;
        if (i >= count) select.value = '';
      });
      if (this.summarySet) this.summarySet.textContent = tier.dataset.label || '';
      if (this.summaryPrice) this.summaryPrice.textContent = tier.dataset.price || '';

      if (!quiet) this.paint();
    }

    paint() {
      const total = this.selects.length;
      const chosen = this.selects.map((s) => s.value);
      const filled = chosen.filter(Boolean).length;

      const tier = this.syncTier(filled);
      const complete = this.isComplete(filled, tier);
      this.pickerSaving = this.savingsFor(tier);

      /* How many wells to draw (Antoine, 2026-08-19). Not all eight.

         The grid used to render every slot the largest set can hold, so a
         shopper on the two-design kit met eight squares and six of them were
         nothing to do with what she was buying. It read as an unfinished
         order rather than as an invitation.

         The rule is the tier's own size, plus ONE — the next square is the
         invitation, and it carries the discount that filling it unlocks:

           tier 2, nothing filled  -> 2 wells   (Design 1, Design 2)
           tier 2, both filled     -> 3 wells   (the third is the invitation)
           fill it: tier is now 4  -> 4 wells   (three filled, one to finish)
           fill that              -> 5 wells   (the fifth is the invitation)
           fill that: tier is now 8 -> 8 wells

         `lastFilled` is belt and braces. Every path today keeps the filled
         values at the low indices — pickTier clears anything past the tier —
         but a well that exists in the form and not on screen would be a design
         the shopper cannot see or remove, and that is worth one max(). */
      const lastFilled = chosen.reduce((at, v, i) => (v ? i : at), -1);
      const size = tier ? Number(tier.dataset.count) : total;
      const visible = Math.min(total, Math.max(size, filled + 1, lastFilled + 1));

      this.slots.replaceChildren(
        ...chosen.slice(0, visible).map((value, i) => this.slot(value, i, size))
      );

      /* Counted against the SET, not against the biggest one the shop sells.
         "0/8" on a two-design kit reads as six missing designs, when two is a
         complete order — the tier is what the shopper is buying, so it is what
         the tally measures. */
      const head = this.querySelector('[data-bundle-count]');
      const goal = tier ? Number(tier.dataset.count) : total;
      if (head) head.textContent = `${filled}/${goal}`;

      /* The unlock, not the saving. Hidden entirely when the chosen tier has
         nothing to unlock, because "Inclus : —" is a row that says nothing. */
      const savedLine = this.querySelector('[data-bundle-saved]');
      const perkLine = this.querySelector('[data-bundle-perk-line]');
      if (savedLine) savedLine.textContent = tier?.dataset.perk || '';
      if (perkLine) perkLine.hidden = !tier?.dataset.perk;

      if (this.summarySet) this.summarySet.textContent = tier?.dataset.label || '';
      if (this.summaryPrice) this.summaryPrice.textContent = tier?.dataset.price || '';
      const reference = this.querySelector('[data-summary-reference]');
      if (reference) { reference.textContent = this.pickerSaving.reference || ''; reference.hidden = !this.pickerSaving.percent; }
      const badge = this.querySelector('[data-summary-saving]');
      if (badge) { badge.textContent = `−${this.pickerSaving.percent}%`; badge.hidden = !this.pickerSaving.percent; }
      const was = this.querySelector('[data-summary-was]');
      if (was) {
        was.hidden = !this.pickerSaving.percent;
        was.textContent = Number(tier?.dataset.count) < 4 ? this.dataset.pickerReferenceLabel : this.dataset.pickerGelReferenceLabel;
      }

      const unit = this.querySelector('[data-summary-unit]');
      if (unit) {
        // Hidden rather than dashed while the set is not a size the shop
        // prices: a per-design figure with no variant behind it would be the
        // component doing arithmetic, which is the one thing it must not do.
        unit.hidden = !tier?.dataset.unit;
        unit.textContent = tier?.dataset.unit
          ? (this.slots.dataset.unitFormat || '').replace('%s', tier.dataset.unit)
          : '';
      }

      /* The "Économisé 14,85 €" pill is gone rather than reworded. The unlock
         line above the ladder and the per-design figure beside the price
         already carry the value story, and a third element restating it as an
         amount saved puts the discount framing straight back on the page. */

      /* Two states, and `current` is READ FROM THE TIER, not recomputed.

         It used to be "the largest step at or below the count", with a comment
         claiming that was "the tier the order is actually priced at". It is
         not: `tierFor` returns the CEILING — the smallest tier that can hold
         what is filled — so with three designs picked out of 2/4/8 the order is
         priced at the 4 tier while the ladder ticked 2 and showed its −17 %.
         The whole point of the band is that quantity and saving move together,
         and between thresholds it was showing a saving the shopper was not
         getting. Two rules for one fact is how that happens; there is one now.

         `is-reached` keeps counting up from below, which is the honest pair:
         at three filled you have passed the 2 step and you are working toward
         the 4 — and the button stays disabled until the set is actually
         complete, which `isComplete` decides on the same tier object. */
      const steps = [...this.querySelectorAll('[data-ladder-step]')];
      const currentAt = tier ? Number(tier.dataset.count) : 0;
      for (const step of steps) {
        const at = Number(step.dataset.ladderStep);
        step.classList.toggle('is-reached', at === currentAt && filled >= at);
        step.classList.toggle('is-current', at === currentAt);
        step.classList.toggle('is-passed', at < currentAt);
        step.classList.toggle('is-complete', at === currentAt && filled === at);
      }

      if (this.done) this.done.hidden = !complete;
      this.paintPicker();

      // Priced only when the filled count is a set size the shop actually
      // sells. Anything else says so instead of pretending.
      const upgradeBlocked = this.upgradeKey && this.upgradeState !== 'ready';
      const purchasable = !this.browseOnly && !upgradeBlocked && tier?.dataset.available === 'true';
      this.add.disabled = !purchasable;
      this.add.setAttribute('aria-disabled', String(!complete || !purchasable));
      /* Incomplete, the button names the next thing to do and does it — the
         reference labels it "Choose Design 1" rather than dimming an add
         button, and a control that says what it wants is better than one that
         refuses and explains underneath. It is still a submit button and still
         aria-disabled for the form: the click handler intercepts it while the
         set is not a size the shop prices, so nothing unpriced is ever posted. */
      this.nextEmpty = complete ? -1 : this.selects.findIndex((s) => !s.value);
      if (this.addLabel) {
        if (upgradeBlocked) {
          this.addLabel.textContent = this.upgradeState === 'loading' || this.upgradeState === 'saving'
            ? this.dataset.upgradeLoading : this.dataset.upgradeReview;
        } else if (!purchasable) {
          this.addLabel.textContent = this.browseOnly
            ? this.addLabel.dataset.preview
            : this.addLabel.dataset.unavailable;
        } else if (complete) {
          this.addLabel.textContent = this.upgradeKey ? this.dataset.upgradeSubmit : this.addLabel.dataset.ready;
        } else if (this.nextEmpty > -1) {
          this.addLabel.textContent = (this.addLabel.dataset.choose || '')
            .replace('%n', String(this.nextEmpty + 1));
        } else {
          this.addLabel.textContent = this.addLabel.dataset.more;
        }
      }
      /* "Two more to go", not "this is not a size we sell". With the tier
         following the count, what is missing is always a number of designs, so
         the line says how many — and it is the only place that has to know,
         because the button already names the next one. */
      if (this.why) {
        const missing = tier ? Number(tier.dataset.count) - filled : 0;
        this.why.hidden = complete;
        this.why.textContent = complete
          ? ''
          : (missing > 0
              ? (missing === 1 ? this.slots.dataset.moreOne : this.slots.dataset.moreOther || '')
                  .replace('%n', String(missing))
              : (this.slots.dataset.incomplete || ''));
      }
    }

    slot(value, index, size) {
      const li = document.createElement('li');
      li.className = 'slot-cell';
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.slot = String(index);
      /* Past the tier's own size, this well is the invitation rather than a
         hole in the order — so it says so, and the button that buys the set
         does not wait on it. */
      const optional = index >= (size || 0);
      button.className = value ? 'slot' : 'slot slot--empty';
      if (optional && !value) button.classList.add('slot--optional');

      const option = value && this.picker?.querySelector(`[data-design="${CSS.escape(value)}"]`);
      const media = document.createElement('span');
      if (option) {
        media.className = 'slot__media';
        media.innerHTML = option.querySelector('.picker__media')?.innerHTML || '';
      } else {
        media.className = 'slot__blank';
        media.textContent = '+';
        const nextTier = optional ? this.tiers.find(item => Number(item.dataset.count) > size) : this.tierFor(this.selects.filter(select => select.value).length);
        const benefit = this.savingsFor(nextTier);
        if (benefit.percent > 0) {
          const badge = document.createElement('small'); badge.className = 'slot__empty-saving'; badge.textContent = `−${benefit.percent}%`; badge.title = benefit.label; media.append(badge);
        }
        media.setAttribute('aria-hidden', 'true');
      }
      button.append(media);

      // Every slot carries the name row whether or not it has a name in it.
      // Only filled ones having it made them 27px taller than their empty
      // neighbours, so the two rows of the grid did not line up. Empty, it
      // names the slot — "Design 3" — which is what the reference captions
      // them with and what the <label> on the field behind it already says.
      const name = document.createElement('span');
      name.className = 'slot__name';
      name.textContent = value
        || (optional ? (this.slots.dataset.optionalLabel || '') : '')
        || this.selects[index]?.labels?.[0]?.textContent
        || '';
      if (!value) name.classList.add('slot__name--placeholder');
      button.append(name);
      if (value && this.pickerSaving?.percent > 0) {
        const saving = document.createElement('small');
        saving.className = 'slot__saving';
        saving.textContent = this.pickerSaving.label;
        button.append(saving);
      }
      // No visually-hidden copy of the label any more: the caption above IS the
      // label now, and a second one only made the button announce "Design 3
      // Design 3".

      li.append(button);

      if (value) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'slot__clear';
        clear.dataset.slotClear = String(index);
        clear.innerHTML = '<span aria-hidden="true">&times;</span>';
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = value;
        clear.append(label);
        li.append(clear);
      }
      return li;
    }

    removeDesign(index) {
      this.selectionStarted = true;
      const retained = this.selects.map(select => select.value).filter((value, at) => value && at !== index);
      this.selects.forEach((select, at) => { select.value = retained[at] || ''; });
      this.active = retained.length < this.selects.length ? retained.length : -1;
      this.wanted = null;
      this.paint();
    }

    savingsFor(tier) {
      if (!tier) return { percent: 0, label: '' };
      const count = Number(tier.dataset.count);
      const options = [...(this.picker?.querySelectorAll('[data-design]') || [])];
      const base = Number(options[0]?.dataset.designPrice || 0);
      let value = this.selects.slice(0, count).reduce((sum, select) => sum + Number(options.find(option => option.dataset.design === select.value)?.dataset.designPrice || base), 0);
      if (count < 4) value += Number(this.dataset.prepPrice || 0) + Number(this.dataset.oilPrice || 0);
      const price = Number(tier.dataset.priceRaw || 0);
      const percent = value > price && price > 0 ? Math.round((value - price) / value * 100) : 0;
      const label = (count < 4 ? this.dataset.pickerSetValue : this.dataset.pickerGelValue).replace('%n', String(percent));
      const reference = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(value / 100);
      return { percent, label, reference };
    }

    switchPickerTab(name) {
      this.picker.querySelectorAll('[data-picker-tab]').forEach(tab => {
        const selected = tab.dataset.pickerTab === name;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.picker.querySelectorAll('[data-picker-panel]').forEach(panel => { panel.hidden = panel.dataset.pickerPanel !== name; });
    }

    paintPicker() {
      if (!this.picker) return;
      const chosen = this.selects.map(select => select.value);
      const filled = chosen.filter(Boolean).length;
      const tier = this.tierFor(filled);
      const count = Number(tier?.dataset.count || 0);
      const saving = this.savingsFor(tier);
      const tally = this.picker.querySelector('[data-picker-count]');
      if (tally) tally.textContent = `${filled}/${count} · ${tier?.dataset.price || ''}`;
      const summary = this.picker.querySelector('[data-picker-total-saving]');
      if (summary) { summary.textContent = saving.label; summary.hidden = saving.percent <= 0; }
      const oil = this.picker.querySelector('[data-picker-included-oil]');
      if (oil) oil.hidden = count === 4;
      for (const option of this.picker.querySelectorAll('[data-design]')) {
        const quantity = chosen.filter(value => value === option.dataset.design).length;
        option.classList.toggle('is-selected', quantity > 0);
        option.setAttribute('aria-pressed', String(quantity > 0));
        const add = option.querySelector('[data-picker-add]');
        if (add) add.textContent = quantity ? `${this.dataset.pickerAnotherLabel} · ${quantity}` : this.dataset.pickerAddLabel;
        const minus = option.parentElement.querySelector('[data-picker-decrement]');
        if (minus) minus.hidden = quantity === 0;
        const badge = option.querySelector('[data-picker-saving]');
        if (badge) { badge.textContent = saving.label; badge.hidden = saving.percent <= 0; }
        const original = option.querySelector('[data-picker-original]');
        const unit = option.querySelector('[data-picker-unit]');
        const discounted = count >= 4 && Number(option.dataset.designPrice) > Number(tier?.dataset.priceRaw) / count;
        if (original) original.style.textDecoration = discounted ? 'line-through' : '';
        if (unit) { unit.hidden = !discounted; unit.textContent = tier?.dataset.unit || ''; }
        option.disabled = this.active < 0;
      }
      const tray = this.picker.querySelector('[data-picker-tray]');
      if (!tray) return;
      tray.replaceChildren(...chosen.slice(0, Math.min(this.selects.length, Math.max(count, filled + 1))).map((value, index) => {
        const cell = document.createElement('li');
        const button = document.createElement('button'); button.type = 'button'; button.dataset.pickerSlot = String(index); button.className = 'picker-plan__slot';
        button.classList.toggle('is-active', index === this.active);
        const option = [...this.picker.querySelectorAll('[data-design]')].find(item => item.dataset.design === value);
        if (option) {
          const img = document.createElement('img'); img.src = option.dataset.designImage; img.alt = value; img.width = 64; img.height = 64; button.append(img);
        } else { button.textContent = '+'; const hint = document.createElement('small'); hint.className = 'picker-plan__empty-saving'; const slotSaving = index >= count ? this.savingsFor(this.tiers.find(item => Number(item.dataset.count) > count)) : saving; hint.textContent = slotSaving.percent > 0 ? `−${slotSaving.percent}%` : ''; button.append(hint); button.setAttribute('aria-label', this.selects[index]?.labels?.[0]?.textContent || String(index + 1)); }
        cell.append(button);
        if (value) {
          const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.pickerRemove = String(index); remove.className = 'picker-plan__remove'; remove.textContent = '×'; remove.setAttribute('aria-label', this.dataset.pickerRemoveLabel.replace('%s', value)); cell.append(remove);
          const label = document.createElement('small'); label.textContent = saving.percent > 0 ? `${saving.percent}%` : ''; label.title = saving.label; cell.append(label);
        }
        return cell;
      }));
    }

    open(index) {
      this.active = index;
      this.switchPickerTab('manicure');
      this.paintPicker();
      if (typeof this.picker?.showModal === 'function') this.picker.showModal();
    }

    filter(term) {
      const needle = term.trim().toLowerCase();
      let shown = 0;
      for (const option of this.picker.querySelectorAll('[data-design]')) {
        const tags = (option.dataset.designTags || '').split('|').filter(Boolean);
        const byTag = !this.tag || tags.includes(this.tag);
        const byName = !needle || option.dataset.design.toLowerCase().includes(needle);
        const match = byTag && byName;
        option.closest('li').hidden = !match;
        if (match) shown += 1;
      }
      const empty = this.picker.querySelector('[data-picker-empty]');
      if (empty) empty.hidden = shown > 0;
    }
  }

  if (!customElements.get('set-builder')) customElements.define('set-builder', SetBuilder);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shape-picker"] && !Shopify.designMode) return;
  try {
    /* The chosen shape is named beside the label, the way a colour swatch names
     its colour. Nothing else here — the radios are a real variant option and
     Shopify's own form handles the rest. */
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-shape]');
    if (!input) return;
    const picker = input.closest('[data-ref="pdp-shape-picker"]');
    const label = picker?.querySelector('[data-shape-chosen]');
    if (label) label.textContent = input.value;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    /* Turns two rows of radios into one variant id.
     The form posts `id`; these radios post nothing — they are removed from the
     submitted data by name (`option-1`) and only exist to drive this. */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const source = this.querySelector('[data-vpick-variants]');
      if (!source) return;
      try { this.variants = JSON.parse(source.textContent); } catch { return; }

      this.form = this.closest('form');
      this.select = this.form?.querySelector('.buy__variants');
      this.idField = this.form?.querySelector('input[name="id"]');

      // The select is the scripts-blocked control and the source of truth for
      // `id`. With scripts, it becomes the hidden field this component writes.
      if (this.select) {
        this.select.hidden = true;
        this.select.setAttribute('aria-hidden', 'true');
        this.select.tabIndex = -1;
      }

      if (!this.bound) {
        this.bound = true;
        this.addEventListener('change', (event) => {
          if (!event.target.matches('[data-vpick-input], [data-shape]')) return;
          this.apply();
        });
      }
      this.apply();
    }

    /* Option values in the order Shopify stores them, so a variant's
       `options` array can be compared position by position. */
    chosen() {
      const values = [];
      for (const group of this.querySelectorAll('[data-option]')) {
        const on = group.querySelector('[data-vpick-input]:checked');
        values.push({ name: group.dataset.option, value: on?.value ?? null });
      }
      const shape = this.querySelector('[data-shape]:checked');
      if (shape) values.push({ name: this.dataset.shapeOption, value: shape.value });
      return values;
    }

    /* A variant matches when every chosen value appears in its option list.
       Position-independent on purpose: which option is first is the merchant's
       to change in Admin, and a picker that breaks when they reorder is a
       picker that will break. */
    find(values) {
      return this.variants.find((v) =>
        values.every(({ value }) => value === null || v.options.includes(value)));
    }

    apply() {
      const values = this.chosen();
      const match = this.find(values);

      for (const group of this.querySelectorAll('[data-option]')) {
        const label = this.querySelector(`[data-chosen="${CSS.escape(group.dataset.option)}"]`);
        const on = group.querySelector('[data-vpick-input]:checked');
        if (label && on) label.textContent = on.value;

        // Availability is asked per pill, holding every other choice fixed:
        // "if I switch to M, does a variant exist that I can buy?"
        for (const input of group.querySelectorAll('[data-vpick-input]')) {
          const probe = values.map((v) => v.name === group.dataset.option ? { ...v, value: input.value } : v);
          const candidate = this.find(probe);
          input.disabled = !candidate || !candidate.available;
        }
      }

      const chosenShape = this.querySelector('[data-shape]:checked');
      const shapeLabel = this.querySelector('[data-shape-chosen]');
      if (shapeLabel && chosenShape) shapeLabel.textContent = chosenShape.value;

      if (!match) return;
      if (this.select) this.select.value = String(match.id);
      if (this.idField) this.idField.value = String(match.id);

      /* Everything else on the page that states a price listens for this —
         the buy block's own figure, the sticky bar, the offer rows. Bubbles,
         because those live outside this element. */
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: match }));
    }
  }

  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
